import { useGameDebugGui } from './useGameDebugGui'

export function DebugGuiMount() {
    useGameDebugGui({ enabled: true })
    return null
}